import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import Config from '../../config';
import Button from 'react-bootstrap/Button';
import NotificationTextDataset from './datasets/notification_text_dataset';
import WaysToIncreaseCash from './text/ways_to_increase_cash';
import GameElementHelp from './text/game_element_help';
import NumberedListCard from './numbered_list_card';
import {replaceTextInString} from '../../objects/CommonUse/replace_text_in_string';
import calcProtectPlanAmts from './objects/calc_protect_plan_amts';
import { buildUrl } from '../../objects/CommonUse/build_URL';
import { setHeadersForFetch } from "../../objects/CommonUse/set_headers_for_fetch";


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData
    // add other Redux state slices here if needed
});

class NotificationModal extends Component {
  constructor(props) {
    super(props);
    this.gameData = this.props.gameData;
    this.state={
         notificationText: NotificationTextDataset,
         rerender: false,
         headers: setHeadersForFetch(),
         environment: Config.dataURL.currentEnv,
    };   
    this.displayModalLink = false;
    this.textArr = [];
    this.modalTitle = "";
    this.imageSrc = "";
    this.link = "";
    this.textArr = [];
  }

  preProcess(){
      this.determineModalClass();
      this.determineModalText();
      this.buildModalLinks();
      this.setState({rerender: !this.state.rerender});
  }

  determineModalClass(){
      if (this.props.notifyInfo.category === "goodNews"){
            this.modalClass = "goodNewsModal";
            this.modalBackground = "goodNewsModalBackground";
            this.modalType = "Good News";
            this.headerStyle = {
              backgroundColor: '#97FFBA'
            }
      }
      if (this.props.notifyInfo.category === "warning"){
            this.modalClass = "gameWarningModal"
            this.modalBackground = "gameWarningModalBackground"
            this.modalType = "Warning";
            this.headerStyle = {
              backgroundColor: '#FFFF99'
            }
      }
      if (this.props.notifyInfo.category === "information"){
        this.modalClass = "gameInfoModal"
        this.modalBackground = "gameInfoModalBackground"
        this.modalType = "Information";
        this.headerStyle = {
          backgroundColor: 'white'
        }
  }
      this.headerClass = this.modalBackground;
      this.footerClass = this.modalBackground + " text-right"
  }

  determineModalText(){
       this.textArr  = [];
       let notificationText = this.state.notificationText;
       for (let i=0; i<notificationText.length; i++){
            if (notificationText[i].notificationType === this.props.notifyInfo.type){
                this.modalText1 = notificationText[i].text[0];
                this.modalText2 = notificationText[i].text[1];
                if (this.props.notifyInfo.firstTime === true &&
                    this.props.notifyInfo.additionalInfo  &&
                    this.props.notifyInfo.additionalInfo !== "" &&
                    this.props.notifyInfo.additionalInfo.firstTimeText){ 
                      this.modalText1 = notificationText[i].firstTimeText + this.modalText1;
                }
                if (notificationText[i].notificationImg !== ""){ 
                    this.imageSrc = "./assets/Icons/" + notificationText[i].notificationImg;
                    this.modalImg = true;
                }else{
                      this.modalImg = false;
                }
                this.modalTitle = notificationText[i].modalTitle;
                if (notificationText[i].textArr !== ""){
                    //  can use this for other things in the future but right now
                    //  this is only used for the warning modals.
                      this.determineTextArr(notificationText[i].textArr);
                }
                if (!notificationText[i].modalSize){
                    this.modalSize = "sm";
                }else{
                    this.modalSize = notificationText[i].modalSize;
                }
                break;
            }
       } 
       this.modalText1 = this.replaceTextInString(this.modalText1);
       if (this.modalText2){
          this.modalText2 = this.replaceTextInString(this.modalText2);
       }
  }

  replaceTextInString(textString){
       if (textString.includes("||")){
            let replaceObj = {};
            if (this.gameData.pendingJob){
                 replaceObj = {...this.props.notifyInfo.additionalInfo, 
                  jobStartDate: this.gameData.pendingJob.jobStartDate};
            }else{
                  replaceObj = this.props.notifyInfo.additionalInfo;
            }
            textString = replaceTextInString(textString, replaceObj);
       }
       return textString;
  }
   
  async determineTextArr(arrayName){
      switch (arrayName){
        case "WaysToIncreaseCash":
            this.textArr  = WaysToIncreaseCash;
            break;
        case "GameElementHelp":
            this.textArr  = GameElementHelp;
             break;
        case "AdditionalInfo":
            if (this.props.notifyInfo.type === "protectionPlan"){
                await this.loadGameProtectPlanTrans()
                this.textArr = this.protectPlanAdditionalInfo.textArr;
                this.setState({rerender: !this.state.rerender});
            }else{
                this.textArr = this.props.notifyInfo.additionalInfo;
            }
            break;
        default:
            break;
      }
  }

  buildModalLinks(){
      const notificationObj = 
        this.state.notificationText.find(elem => elem.notificationType === this.props.notifyInfo.type);
      if (notificationObj.link && notificationObj.link !== "") {
        this.link = notificationObj.link;
        this.displayModalLink = true;
      }
  }

  render() { 
      if (this.textArr.length > 5){
          this.modalSize = "med";
      }
      if (!this.textArr){
        this.textArr = [];
      }
      this.numberedList = this.textArr.map((textLine, key) =>
            <NumberedListCard key={key} text={textLine} />
      );
  
  return <>
   
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} 
            size={this.modalSize} animation={false}>
        <Modal.Header className={this.modalBackground} closeButton>
            <Modal.Title>{this.modalType}</Modal.Title> 
          </Modal.Header>
          <Modal.Body className={`custom-scroll-modal-body ${this.modalClass}`}>
                 <span>    
                    {this.modalImg ?
                      <div className="text-center">
                          <img className="medLarge_sign_thumbnail_img" src={this.imageSrc} alt="iconPicture"/>
                      </div>
                    :
                      null
                    }
                    <h4 className="text-center mt-2">{this.modalTitle}</h4>   
                    <div className="mt-2 mx-0 small-text">
                          {this.modalText1}
                    </div>
                    <div className= "mt-1 mx-0 small-text">
                          {this.modalText2}
                    </div>
                    <div className="mt-1 mx-0 small-text">
                          <ol className="text-left mx-3 small-text" type="1">
                              {this.numberedList}
                          </ol>
                    </div>  
                    {this.displayModalLink ?
                        <div
                           className="decorative light-blue-color text-center text-pointer "
                              onClick={() => this.goToLink(this.link)}><u>Link</u>
                        </div>
                    :
                    null
                    }
                  </span>
            
          </Modal.Body>
          <Modal.Footer className={this.footerClass}>
              <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                alt="trainIcon"/>
              <Button  variant="info"   onClick={() => this.props.onClose()}>
                   Close
              </Button>
          </Modal.Footer>
          </Modal>
    
    </>
  }

    componentDidMount(){
        this._isMounted = true;
        this.preProcess();
        
    }

    componentDidUpdate(prevProps){
        if (prevProps.notifyInfo !== this.props.notifyInfo){ 
            this.preProcess();
        }
    }

    goToLink(){
        this.props.deleteNotification(this.props.notifyInfo.type);
        this.props.onNavigate(this.link);
    }

    async loadGameProtectPlanTrans(){
        const funcName = "loadGameProtectPlanTrans";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        const response = await fetch(uri, {method: 'GET', headers: this.state.headers});

        if (response.ok){
            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.protectPlanAdditionalInfo = calcProtectPlanAmts(output.body, this.gameData.currentGameDate);
                if (this.protectPlanAdditionalInfo.orphanSavedTrans &&
                    this.protectPlanAdditionalInfo.orphanSavedTrans.length > 0 ){
                        const errorObj = {function: funcName, subProcess: this.subProcess,
                            status: "999", message: "Saved Protect Plan Trans not applied to plan", silentAlert: true};
                        this.processErrorReturn(errorObj);
                }
            }else{
                const errorObj = {function: funcName, subProcess: this.subProcess,
                    status: statusCode, message: output.body.message};
                this.processErrorReturn(errorObj);
            }
        }
    }

 
}
export default connect(mapStateToProps)(NotificationModal);